import React, { useState, useEffect } from "react";
import { MdOutlineLogin } from "react-icons/md";
import { scroller } from "react-scroll";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Logo from "../../Images/new logo 2.png";
import Logo1 from "../../Images/orrangeMainLogo.png";
// import Logo from "../../Images/mainLogo-removebg-preview.png";
function HomeNavbar() {
  const navigate = useNavigate();
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [data, setData] = useState([]);
  const [activeSection, setActiveSection] = useState("home");

  // useEffect(() => {
  //   async function fetchData() {
  //     try {
  //       const response = await axios.get("getAllCourses");
  //       if (response?.data) {
  //         setData(response?.data?.result);
  //         localStorage.setItem("plans", JSON.stringify(response?.data?.result));
  //       }
  //     } catch (error) {
  //       console.error("Error fetching data:", error);
  //     }
  //   }
  //   fetchData();
  // }, []);

  console.log(data);

  const scrollToSection = (sectionId) => {
    setActiveSection(sectionId);
    scroller.scrollTo(sectionId, {
      duration: 800,
      delay: 0,
      smooth: "easeInOutQuart",
    });
  };

  useEffect(() => {
    const handleScroll = () => {
      const elements = document.querySelectorAll(".animate-on-scroll");
      elements.forEach((element) => {
        const rect = element.getBoundingClientRect();
        if (rect.top < window.innerHeight) {
          element.classList.add("animate-fade-in-on-scroll");
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const [slideIn, setSlideIn] = useState(false);

  useEffect(() => {
    setSlideIn(true);
  }, []);
 const linkClass = (section) =>
    `relative flex items-center justify-between py-3 px-3 rounded-lg
     transition-all duration-200
     ${
       activeSection === section
         ? "text-purple bg-white/10"
         : "text-white hover:bg-white/5 hover:text-purple"
     }`;
  return (
    <>
      <nav className="fixed top-0 bg-white text-black font-oswald text-lg py-2 px-6 w-full z-10 shadow-xl">
        <div className="container mx-auto flex items-center justify-between">
          <div className="text-2xl font-bold lg:ml-4">
            <a href="/" className="flex items-center ">
              <img className="w-36 h-18" src={Logo} alt="" />
            </a>
          </div>
          <div className="mb-2 md:mb-0 lg:ml-10">
            <a href="/" className="flex items-center ">
              {/* <img src={Logo} className="h-8 me-3 w-14" alt="" /> */}
              {/* <span
                className="self-center text-3xl font-[700 ] whitespace-nowrap dark:text-bgBlue text-bgBlue"
                style={{ textShadow: "1px 1px 3px rgba(0, 0, 0, 0.7)" }}
              >
                Learn2<span className="text-purple">ern</span>
              </span> */}
            </a>
          </div>

          <div className="hidden md:flex space-x-6 items-center font-bold text-bgBlue">
            <a
              href="/"
              className={`hover:underline ${
                activeSection === "home" ? "text-purple" : ""
              }`}
              onClick={() => scrollToSection("home")}
            >
              Home
            </a>
            <a
              href="#plans"
              className={`hover:underline ${
                activeSection === "plans" ? "text-purple" : ""
              }`}
              onClick={() => scrollToSection("plans")}
            >
              Plans
            </a>
            <a
              href="/about-us"
              className={`hover:underline ${
                activeSection === "about-us" ? "text-purple" : ""
              }`}
              onClick={() => scrollToSection("about-us")}
            >
              About Us
            </a>
            <a
              href="/contact-us"
              className={`hover:underline ${
                activeSection === "contact-us" ? "text-purple" : ""
              }`}
              onClick={() => scrollToSection("contact-us")}
            >
              Contact Us
            </a>
            <a
              href="#faqs-page"
              className={`hover:underline ${
                activeSection === "faq" ? "text-purple" : ""
              }`}
              onClick={() => scrollToSection("faq")}
            >
              FAQ
            </a>
            <a
              href="/login"
              className=" px-7 rounded-full py-1 bg-purple text-white hover:bg-blue-600 shadow-[6px_6px_#4D2C5E]"
            >
              Login
            </a>
          </div>
          <div className="flex gap-4 md:hidden ">
            {/* <a
              href="/login"
              className="px-4 py-1.5 text-2xl text-white rounded-full hover:bg-blue-600"
            >
              <MdOutlineLogin />
            </a> */}
            <button
              className="flex items-center"
              onClick={() => setIsNavOpen(!isNavOpen)}
            >
              <i className="fas fa-bars text-2xl text-bgBlue"></i>
            </button>
          </div>
        </div>
        {/* Sidebar */}
        <div
      className={`fixed top-0 right-0 bg-bgBlue text-white w-64 h-full
      transform transition-transform duration-300
      ${isNavOpen ? "translate-x-0" : "translate-x-full"}
      z-50 flex flex-col`}
    >
      {/* ===== TOP BAR ===== */}
      <div className="flex justify-end items-center p-4 border-b border-white/10">
        <button
          className="text-2xl"
          onClick={() => setIsNavOpen(false)}
        >
          <i className="fas fa-times text-purple"></i>
        </button>
      </div>

      {/* ===== MENU ===== */}
      <div className="flex flex-col px-4 py-2">
        <a
          href="/"
          className={linkClass("home")}
          onClick={() => {
            scrollToSection("home");
            setIsNavOpen(false);
          }}
        >
          Home
        </a>
        <div className="h-px bg-white/10 my-1" />

        <a
          href="#plans"
          className={linkClass("plans")}
          onClick={() => {
            scrollToSection("plans");
            setIsNavOpen(false);
          }}
        >
          Plans
        </a>
        <div className="h-px bg-white/10 my-1" />

        <a
          href="/about-us"
          className={linkClass("about-us")}
          onClick={() => {
            scrollToSection("about-us");
            setIsNavOpen(false);
          }}
        >
          About Us
        </a>
        <div className="h-px bg-white/10 my-1" />

        <a
          href="/contact-us"
          className={linkClass("contact-us")}
          onClick={() => {
            scrollToSection("contact-us");
            setIsNavOpen(false);
          }}
        >
          Contact Us
        </a>
        <div className="h-px bg-white/10 my-1" />

        <a
          href="#faq"
          className={linkClass("faq")}
          onClick={() => {
            scrollToSection("faq");
            setIsNavOpen(false);
          }}
        >
          FAQ
        </a>

        {/* ===== LOGIN BUTTON ===== */}
        <a
          href="/login"
          className="mt-4 text-center px-4 py-2
          bg-purple rounded-full text-white font-medium
          hover:scale-[1.02] transition
          shadow-[4px_4px_#A695AE]"
          onClick={() => setIsNavOpen(false)}
        >
          Login
        </a>
      </div>

      {/* ===== BOTTOM LOGO ===== */}
      <div className="mt-auto pb-6 pt-4 border-t border-white/10">
        <a href="/" className="flex justify-center">
          <img
            src={Logo1}
            alt="Learn2Earn Logo"
            className="w-36 opacity-90"
          />
        </a>
      </div>
    </div>
      </nav>
    </>
  );
}

export default HomeNavbar;
